import { Box, Text, ThemeContext } from 'grommet';
import React, { useContext } from 'react';
import { HideInPrint, VisibleOnlyInPrint } from '../utils/print';
import { DarkModeCompatibleImage } from '../utils/styled';

const MerchantHeader = ({data, hideContact, containerProps={}, centerAlignLogo}) => {
    const theme = useContext(ThemeContext);
    return (
        <Box align="center" justify="between" direction="row" id="merchant-header" {...containerProps}>
            {/*
                justify="center", not "between". This box holds two children - the
                screen logo and its print-only twin - so "between" pinned the visible
                one to the top of a box as tall as the contact block beside it, leaving
                the logo's centre 33px above the contact block's. centerAlignLogo now
                does what its name says and controls the horizontal alignment.
            */}
            <Box flex="grow" width={{max: "small"}} height="xsmall" justify="center" align={centerAlignLogo ? "center" : "start"}>
                <HideInPrint>
                    {data?.logo && (<DarkModeCompatibleImage width="100%" fill={'vertical'} fit={'contain'} alt={`${data?.business_name} logo`} src={data.logo} dark={theme.dark} />)}
                </HideInPrint>
                <VisibleOnlyInPrint>
                    {data?.logo && (<DarkModeCompatibleImage width="100%" fill={'vertical'} fit={'contain'} alt={`${data?.business_name} logo`} src={data.logo} dark={false} />)}
                </VisibleOnlyInPrint>
            </Box>
            {!hideContact && (
                <Box pad={{horizontal: 'small'}} align="end"  skeleton={!data ? {animation: 'fadeIn'} : undefined }>
                    <Text weight={600}>{data?.business_name || ""}</Text>
                    {data?.email && (<Text>{data?.email}</Text>)}
                    {data?.phone_number && (<Text>{data?.phone_number}</Text>)}
                    {!data && <Text></Text>}
                </Box>
            )}
        </Box>
    )
};


export default MerchantHeader;